var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../converters/DateConverter";
import { Country } from "./../Primitives/MasterData/Country";
import { BankAccount } from "./../CompanyInfo/Detail/BankAccount";
export class OssRegistration {
  constructor(_data) {
    /**
     */
    __publicField(this, "BankAccount");
    /**
     */
    __publicField(this, "CertificateReferenceId");
    /**
     */
    __publicField(this, "Country");
    /**
     */
    __publicField(this, "DateOfDeregistration");
    /**
     */
    __publicField(this, "DeregistrationConfirmationDocumentId");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "PaymentReference");
    /**
     */
    __publicField(this, "RegistrationDate");
    /**
     */
    __publicField(this, "RegistrationNumber");
    /**
     */
    __publicField(this, "RegistrationType");
    /**
     */
    __publicField(this, "StartDate");
    /**
     */
    __publicField(this, "Status");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof OssRegistration
     */
    __publicField(this, "$type", "V1.Companies.OssRegistration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["BankAccount"]) {
        const bankAccount_ = new BankAccount();
        this.BankAccount = bankAccount_.init(_data["BankAccount"]);
      }
      this.CertificateReferenceId = _data["CertificateReferenceId"];
      if (_data["Country"]) {
        const country_ = new Country();
        this.Country = country_.init(_data["Country"]);
      }
      this.DateOfDeregistration = DateConverter.from(_data["DateOfDeregistration"]);
      this.DeregistrationConfirmationDocumentId = _data["DeregistrationConfirmationDocumentId"];
      this.Id = _data["Id"];
      this.PaymentReference = _data["PaymentReference"];
      this.RegistrationDate = DateConverter.from(_data["RegistrationDate"]);
      this.RegistrationNumber = _data["RegistrationNumber"];
      this.RegistrationType = OssRegistrationRegistrationType[_data["RegistrationType"]];
      this.StartDate = DateConverter.from(_data["StartDate"]);
      this.Status = OssRegistrationStatus[_data["Status"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["BankAccount"] = this.BankAccount ? this.BankAccount.toJSON() : void 0;
    _data["CertificateReferenceId"] = this.CertificateReferenceId;
    _data["Country"] = this.Country ? this.Country.toJSON() : void 0;
    _data["DateOfDeregistration"] = DateConverter.toUtcDateString(this.DateOfDeregistration);
    _data["DeregistrationConfirmationDocumentId"] = this.DeregistrationConfirmationDocumentId;
    _data["Id"] = this.Id;
    _data["PaymentReference"] = this.PaymentReference;
    _data["RegistrationDate"] = DateConverter.toUtcDateString(this.RegistrationDate);
    _data["RegistrationNumber"] = this.RegistrationNumber;
    _data["RegistrationType"] = OssRegistrationRegistrationType[this.RegistrationType];
    _data["StartDate"] = DateConverter.toUtcDateString(this.StartDate);
    _data["Status"] = OssRegistrationStatus[this.Status];
    return _data;
  }
}
export var OssRegistrationRegistrationType = /* @__PURE__ */ ((OssRegistrationRegistrationType2) => {
  OssRegistrationRegistrationType2["NewRegistration"] = "NewRegistration";
  OssRegistrationRegistrationType2["TakeOver"] = "TakeOver";
  return OssRegistrationRegistrationType2;
})(OssRegistrationRegistrationType || {});
export var OssRegistrationStatus = /* @__PURE__ */ ((OssRegistrationStatus2) => {
  OssRegistrationStatus2["Pending"] = "Pending";
  OssRegistrationStatus2["WaitingForSignature"] = "WaitingForSignature";
  OssRegistrationStatus2["DocumentsSigned"] = "DocumentsSigned";
  OssRegistrationStatus2["SentToTA"] = "SentToTA";
  OssRegistrationStatus2["RegistrationCompleted"] = "RegistrationCompleted";
  OssRegistrationStatus2["Deregistered"] = "Deregistered";
  OssRegistrationStatus2["DeregistrationInProgress"] = "DeregistrationInProgress";
  return OssRegistrationStatus2;
})(OssRegistrationStatus || {});
